import AudiotrackRoundedIcon from "@mui/icons-material/AudiotrackRounded";
import ImageIcon from "@mui/icons-material/Image";
import InsertDriveFileRoundedIcon from "@mui/icons-material/InsertDriveFileRounded";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import VideocamRoundedIcon from "@mui/icons-material/VideocamRounded";

export function GetType(type) {
  // Normalize the type to lowercase to handle cases like .MOV and .mov
  const extension = type?.toLowerCase().split(".").pop(); // Get the extension and convert it to lowercase
  // Define a map of file extensions to categories
  const fileTypes = {
    // PDF
    pdf: "pdf",
    // Audio files
    mp3: "audio",
    wav: "audio",
    flac: "audio",
    aac: "audio",
    ogg: "audio",
    m4a: "audio",
    wma: "audio",
    // Video files
    mp4: "video",
    mov: "video",
    avi: "video",
    mkv: "video",
    webm: "video",
    flv: "video",
    wmv: "video",
    mpeg: "video",
    mpg: "video",
    // Image files
    jpg: "image",
    jpeg: "image",
    png: "image",
    gif: "image",
    bmp: "image",
    tiff: "image",
    webp: "image",
    svg: "image",
  };

  if (fileTypes[extension]) {
    return fileTypes[extension];
  } else {
    return "other";
  }
}

export const GetIcon = (type, AccentColor) => {
  switch (GetType(type?.name)) {
    case "pdf":
      return (
        <PictureAsPdfIcon
          sx={{
            color: AccentColor,
          }}
        />
      );
    case "image":
      return (
        <ImageIcon
          sx={{
            color: AccentColor,
          }}
        />
      );
    case "audio":
      return (
        <AudiotrackRoundedIcon
          sx={{
            color: AccentColor,
          }}
        />
      );
    case "video":
      return (
        <VideocamRoundedIcon
          sx={{
            color: AccentColor,
          }}
        />
      );
    default:
      return (
        <InsertDriveFileRoundedIcon
          sx={{
            color: AccentColor,
          }}
        />
      );
  }
};
